import { render } from "./ClassList.vue?vue&type=template&id=beb46d50&ts=true"
import script from "./ClassList.vue?vue&type=script&lang=ts"
export * from "./ClassList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__